import { LinearGradient } from "expo-linear-gradient";
import { useState } from "react";
import {
  Alert,
  Button,
  Dimensions,
  FlatList,
  Image,
  Keyboard,
  KeyboardAvoidingView,
  Platform,
  Pressable,
  View,
} from "react-native";
import { Modal, StyleSheet, Text, TouchableOpacity } from "react-native";
import {
  ScrollView,
  TextInput,
  TouchableWithoutFeedback,
} from "react-native-gesture-handler";
import { globalStyles } from "../styles/globalStyles";
import Ionicons from "react-native-vector-icons/Ionicons";
import { API } from "aws-amplify";
import { createReviews } from "../src/graphql/mutations";
import KeyBoardAvoidingWrapper from "./components/KeyboardAvoidingWrapper";

export default function CommentModal({
  modalOpen,
  setModalOpen,
  user,
  bookId,
  refresh,
  comments,
  setMainModalOpen,
}) {
  const [comment, setComment] = useState();

  async function handleSubmit() {
    await createNewReview();
    setComment("");
    if (Platform.OS == "web") window.confirm("Your comment has been posted!");
    else Alert.alert("Your comment has been posted!");
    setModalOpen(false);
    setMainModalOpen(false);
    refresh();
  }

  async function createNewReview() {
    try {
      await API.graphql({
        query: createReviews,
        variables: {
          input: {
            comment: comment,
            booksReviewsBookId: bookId,
            reviewsReviewerUId: user.uId,
            profilePicture: user.profilePicture,
          },
        },
      });
    } catch (evt) {
      console.log(evt);
    }
  }

  return (
    <Modal
      visible={modalOpen}
      transparent={true}
      animationType={"fade"}
      style={{ alignItems: "center" }}
    >
      <ScrollView>
        <KeyboardAvoidingView behavior="position" keyboardVerticalOffset={-120}>
          <LinearGradient
            colors={["#66524a", "#332b2d"]}
            style={
              Platform.OS == "web"
                ? {
                    ...styles.modalStyle,
                    width: 600,
                    // height: 700,
                    marginLeft: "30%",
                    marginVertical: "10%",
                  }
                : styles.modalStyle
            }
          >
            <Text style={{ ...globalStyles.subtitleText, color: "#e2cfc2" }}>
              {comments.length == 0 && "Be the first to share!"}
            </Text>
            <ScrollView style={{ height: Dimensions.get("window").height / 3 }}>
              {comments.map((item) => {
                return (
                  <View
                    style={{
                      justifyContent: "flex-start",
                      alignItems: "flex-start",
                      borderColor: "white",
                      borderWidth: 2,
                      borderRadius: 10,
                      margin: 12,
                      flexWrap: "wrap",
                    }}
                    key={item.id}
                  >
                    <View style={{ flexDirection: "row" }}>
                      {item.reviewer.profilePicture == null ? (
                        <Ionicons
                          name="person-circle"
                          size={30}
                          style={{
                            color: "#e2cfc2",
                            marginLeft: 8,
                            marginTop: 5,
                          }}
                        />
                      ) : (
                        <Image
                          source={{
                            uri: item.reviewer.profilePicture,
                            width: 30,
                            height: 30,
                          }}
                          style={{
                            marginLeft: 8,
                            marginTop: 5,
                            borderRadius: 100,
                          }}
                        />
                      )}
                      <Text
                        style={{
                          ...styles.commentStyle,
                          fontSize: 18,
                          marginBottom: -10,
                          color: "#d1d6dc",
                          fontFamily: "quicksand-bold",
                        }}
                      >
                        {item.reviewer.userName}
                      </Text>
                    </View>
                    <Text style={styles.commentStyle}>{item.comment}</Text>
                  </View>
                );
              })}
            </ScrollView>
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
                marginHorizontal: 15,
              }}
            >
              <TextInput
                style={
                  Platform.OS == "web"
                    ? { ...styles.textInput, width: 400 }
                    : styles.textInput
                }
                placeholder={"share your thoughts on this title ..."}
                placeholderTextColor="#a3978e"
                multiline
                onChangeText={(text) => {
                  setComment(text);
                }}
                value={comment}
              />
              <Ionicons
                style={{
                  color: "#a9d1de",
                  marginRight: 10,
                }}
                name="arrow-up-circle"
                size={40}
                onPress={async () => {
                  await handleSubmit();
                }}
              />
            </View>
            <Pressable
              onPress={() => {
                setModalOpen(false);
              }}
              style={{ marginVertical: 5 }}
            >
              <Text
                style={{
                  fontFamily: "quicksand-bold",
                  fontSize: 17,
                  color: "#a9d1de",
                }}
              >
                close
              </Text>
            </Pressable>
          </LinearGradient>
        </KeyboardAvoidingView>
      </ScrollView>
    </Modal>
  );
}

const styles = StyleSheet.create({
  input: {
    ...globalStyles.input,
    borderColor: "#7191ad",
    fontSize: 20,
    marginBottom: 20,
    padding: 10,
  },
  commentStyle: {
    ...globalStyles.subtitleText,
    color: "#e2cfc2",
    fontFamily: "quicksand-normal",
    marginBottom: 10,
    textAlign: "left",
    fontSize: 15,
  },
  modalStyle: {
    justifyContent: "center",
    alignItems: "center",
    marginTop: 200,
    marginBottom: 150,
    marginHorizontal: 30,
    borderRadius: 20,
    flex: 1,
  },
  textInput: {
    ...globalStyles.input,
    fontSize: 17,
    padding: 15,
    borderRadius: 20,
  },
});
